import React, { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";
import axios from "axios";
import $ from 'jquery';
import api from '../../../api/axiosInstance';
const ViewExternalForm = () => {
  debugger;
  const { formId } = useParams(); // Extract form ID from URL
  const [formData, setFormData] = useState(null);
    const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  debugger;
  const [formValues, setFormValues] = useState({});
// const readonlyMode = [121440001].includes(formData?.form?.statusReasonValue);
const [readonlyMode,setReadonlyMode] = useState(false);
const userData = JSON.parse(localStorage.getItem('user')); // Get user info from localStorage
const userId = userData ? userData.id : null; // Get logged-in user email
const [showCommentModal, setShowCommentModal] = useState(false);
const [newCommentText, setNewCommentText] = useState("");
  const[isMandatorysingle,setIsMandatorysingle]=useState(false);
  const[isMandatorysmullti,setIsMandatorymulti]=useState(false);
  const[isMandatorydate,setIsMandatorydate]=useState(false);
  const[isMandatorynumber,setIsMandatorynumber]=useState(false);
const [attachments, setAttachments] = useState([]);
const [selectedFile, setSelectedFile] = useState(null);
   const showAttachmentSection = useState(true);
   const [isSubmitted, setSubmitted]=useState(false);
     const [blocked, setBlocked] = useState(false);


useEffect(() => {
  debugger;
api.get(`/Form/ViewExternalForm/${formId}`) 
    .then((response) => {

      debugger;
      setFormData(response.data);
      console.log(response.data);
      setReadonlyMode([121440001].includes(response.data?.form?.statusReasonValue));
      setLoading(false);

      if(response.data.form.statusReasonValue=== 121440001) {
        setSubmitted(true);
      }
    })
    .catch((err) => {
      setError(err.message || "Something went wrong");
      setLoading(false);
    });
    
      

}, [formId]);

  const fetchAttachments = () => {
api.get(`/FormAttachment/GetFormAttachments?formId=${formData.form.id}`)
    .then((res) => setAttachments(res.data))
    .catch((err) => console.error("Error fetching attachments:", err));
};
      const handleSave = (e) => {debugger;
        setBlocked(true);
  if (e && e.preventDefault) e.preventDefault();

  return new Promise((resolve, reject) => {
    console.log("Saving full form data with updated values...");

    // Step 1: Deep clone formData to avoid mutating original
    const updatedFormData = JSON.parse(JSON.stringify(formData));

    // 👇 Normalize formValues to map by component.id
    const normalizedValues = normalizeFormValues(updatedFormData, formValues);

    // Step 2: Loop through all sections and components
    updatedFormData.listSections?.forEach((section) => {
      section.listComponent?.forEach((component) => {
        const componentId = component.id;

        if (formValues[componentId] !== undefined) {
          const value = formValues[componentId];

          switch (component.typeText) {
            case "Label & Number Textbox":
              component.numberTextboxValue = parseFloat(value) || 0;
              break;

            case "Label & Single Line Textbox":
              component.singleLineTextboxValue = value;
              break;

            case "Label & Multiline Textbox":
              component.multilineTextboxValue = value;
              break;

           case "Label & Date Textbox":
  // if (value && !isNaN(new Date(value))) {
  //   component.dateTextboxValue = new Date(value).toISOString();
  // } case "Label & Date Textbox":
  const rawDate = value?.toString();
  const isEmptyOrMin =
    !rawDate ||
    rawDate === "0001-01-01T00:00:00" ||
    rawDate === "0001-01-01" ||
    isNaN(new Date(rawDate));

  component.dateTextboxValue = isEmptyOrMin
    ? new Date().toISOString() // ⬅️ Use your default here
    : new Date(rawDate).toISOString();
  break;

  break;


            case "Label & Radio Buttons":
              component.radioButtonsValue = parseInt(value) || 0;
              break;

            case "Label & Listbox":
              component.listboxValue = value;
              break;

            case "Label & Checkboxes":
              const checkboxObj = value || {};
              for (let i = 1; i <= 30; i++) {
                component[`checkboxOpt${i}Value`] = checkboxObj[`checkboxOpt${i}Value`] === true;
              }
              break;

            case "Table":
            case "Label & Table":
              if (value && typeof value === "object") {
                component.tableValues = value.values || {};
                component.tableValuesId = value.tableValueId || null;
              }
              break;

            default:
              console.warn(`Unhandled component type: ${component.typeText}`);
              break;
          }
        }
      });
    });
    // Step 3: Add reviewerId to formData if applicable



    // Step 3: Send full updated formData to the backend
    debugger;
    api.post("/MyForms/SaveForm", updatedFormData, {
      headers: { "Content-Type": "application/json" },
    })
      .then((response) => {
        setBlocked(false);
         $.alert({
                  title: 'Success',
                  content: 'Form saved successfully!',
                  type: 'green'
                });
        resolve(response.data); // ✅ Resolve when save is successful
      })
      .catch((error) => {
        console.error("Save error:", error.response?.data || error.message);
        alert("Error saving form.");
        reject(error); // ❌ Reject if error
      });
  });
};


const handleUploadAttachment = () => {
  if (!selectedFile) {
   $.alert({
          title: "",
          content: "Please select a file.",
          type: "red",
        });
  return;
  }
 setBlocked(true);
  const formDataToSend = new FormData();
  formDataToSend.append("File", selectedFile);
  formDataToSend.append("FormId", formData.form.id);
  formDataToSend.append("ContactName", userData.fullName); // 🧠 logged-in user's name

api.post("/FormAttachment/UploadAttachment", formDataToSend)
    .then((res) => {
      if (res.data.success) {
        setBlocked(false);
    $.confirm({
                        title: 'Success ',
                        content: 'Attachment uploaded successfully.',
                        type: 'green',
                      });
        setSelectedFile(null);
        fetchAttachments();
      } else {
        alert("Upload failed.");
      }
    })
    .catch((err) => {
      console.error("Upload error:", err);
      alert("Upload error occurred.");
    });
};

  const ValidatePage = () => {
    debugger;
    var isValid = true;
    var singleline = $("#singleline").val();
    var date = $("#date").val();  
    var multiLine = $("#multiLine").val();
    var number = $("#number").val();
    if (date !== undefined) {
      if(isMandatorydate){
      if (date == null || date === "" )  {
        ActivateDeactivateValidator("date", "spandate", true, "* required");
        isValid = false;
      } else {
        ActivateDeactivateValidator("date", "spandate", false, "");
      }
    }
    }
    if (singleline !== undefined) {
      if(isMandatorysingle){
      if (singleline == null || singleline === "" ) {
        ActivateDeactivateValidator(
          "singleline",
          "spansline",
          true,
          "* required"
        );
        isValid = false;
      } else {
        ActivateDeactivateValidator("singleline", "spansline", false, "");
      }
    }
    }

    if (multiLine !== undefined) {
      if(isMandatorysmullti){
      if (multiLine == null || multiLine === "" ) {
        ActivateDeactivateValidator(
          "multiLine",
          "spanMultiLine",
          true,
          "* required"
        );
        isValid = false;
      } else {
        ActivateDeactivateValidator("multiLine", "spanMultiLine", false, "");
      }
    }
    }
    if (number !== undefined) {
      if(isMandatorynumber){
      if (number == null || number === "") { 
        ActivateDeactivateValidator("number", "spannumber", true, "* required");
        isValid = false;
      } else {
        ActivateDeactivateValidator("number", "spannumber", false, "");
      }
    }
    }
    return isValid;
  };

const handleDeleteAttachment = (noteId) => {
  if (!window.confirm("Are you sure to delete this attachment?")) return;

  api
    .delete(`/FormAttachment/DeleteAttachment/${noteId}`)
    .then((res) => {
      if (res.data.success) {
        fetchAttachments();
      }
    })
    .catch((err) => console.error("Delete error:", err));
};
const  populateComponentValues= (updatedFormData, formValues) =>{
  updatedFormData.listSections?.forEach((section) => {
    section.listComponent?.forEach((component) => {
      const id = component.id;
      const value = formValues?.[id];

      switch (component.typeText) {
        case "Label & Number Textbox":
          component.numberTextboxValue = value != null ? parseFloat(value) || 0 : component.numberTextboxValue || 0;
          if(component.isMandatory===true)
                {
                  setIsMandatorynumber(true);
                }
          break;

        case "Label & Single Line Textbox":
          component.singleLineTextboxValue = value != null ? value : component.singleLineTextboxValue || "";
          if(component.isMandatory===true)
              {
                setIsMandatorysingle(true);
              }
          break;

        case "Label & Multiline Textbox":
          component.multilineTextboxValue = value != null ? value : component.multilineTextboxValue || "";
          if(component.isMandatory===true)
              {
                setIsMandatorymulti(true);
              }
          break;

        case "Label & Date Textbox":
          const rawDate = value?.toString();
          const isEmptyOrMin =
            !rawDate ||
            rawDate === "0001-01-01T00:00:00" ||
            rawDate === "0001-01-01" ||
            isNaN(new Date(rawDate));
          component.dateTextboxValue = isEmptyOrMin ? null : new Date(rawDate).toISOString();
          if(component.isMandatory===true)
              {
                setIsMandatorydate(true);
              }
          break;

        case "Label & Radio Buttons":
          // radio value might be string or number; keep as integer
          component.radioButtonsValue = value != null ? parseInt(value, 10) || 0 : component.radioButtonsValue || 0;
          break;

        case "Label & Listbox":
          component.listboxValue = value != null ? value : component.listboxValue || "";
          break;

        case "Label & Checkboxes":
          // value expected as object { checkboxOpt1Value: true, ... }
          const checkboxObj = value || {};
          for (let i = 1; i <= 30; i++) {
            component[`checkboxOpt${i}Value`] = !!checkboxObj[`checkboxOpt${i}Value`];
          }
          component.checkboxes = Object.values(checkboxObj).filter(v => v === true).length;
          break;

        case "Table":
        case "Label & Table":
          if (value && typeof value === "object") {
            // you store table values in value.values according to your earlier code
            component.tableValues = value.values || {};
            component.tableValuesId = value.tableValueId || null;
          }
          break;

        default:
          // no-op
      }
    });
  });
}

  const Validate = (component) => {
    debugger;
    let valid = true;
    console.log(component);

    if (component.typeValue === 121440009) {
      if (!component.radioButtonsValue || component.radioButtonsValue === 0) {
        ActivateDeactivateValidator("radbtn", "spanrad", true, "* required");
        valid = false;
      } else {
        ActivateDeactivateValidator("radbtn", "spanrad", false, "");
      }
    }
    if (component.typeValue === 121440010) {
      if (!component.checkboxes || component.checkboxes === 0) {
        ActivateDeactivateValidator(
          "checkbox",
          "spancheck",
          true,
          "* required"
        );
        valid = false;
      } else {
        ActivateDeactivateValidator("checkbox", "spancheck", false, "");
      }
    }
    if (component.typeValue === 121440011) {
      if (component.listboxValue === "") {
        ActivateDeactivateValidator(
          "listbox",
          "spanlistbox",
          true,
          "* required"
        );
        valid = false;
      } else {
        ActivateDeactivateValidator("listbox", "spanlistbox", false, "");
      }
    }
    return valid;
  };
   const  ActivateDeactivateValidator = (controlName, validatorName, activate, message) =>  {
    debugger;
            if (activate === true) {
                $('#' + validatorName).removeClass("field-validation-valid").addClass("field-validation-error").text(message).focus();
                $('#' + controlName).focus();
            }
            else {
                $('#' + validatorName).removeClass("field-validation-error").addClass("field-validation-valid").text("");
            }
        }

const ValidateAllComponents = (formData) => {
  let valid = true;

  formData.listSections?.forEach(section => {
    section.listComponent?.forEach(component => {
      if (!Validate(component)) {
        valid = false;
      }
    });
  });

  return valid;
};
const handleSubmit = async () => {
  debugger;
setBlocked(true);
  try {
    const validate=ValidatePage();
    if(!validate)
    {
      setBlocked(false);
      return;
    }
    // 🔥 Validate whole form before submit
      const updatedFormData = JSON.parse(JSON.stringify(formData));

    // 👇 Normalize formValues to map by component.id
  populateComponentValues(updatedFormData, formValues);

    const allValid = ValidateAllComponents(updatedFormData);
    if (!allValid) {
      setBlocked(false);
      return;
    }

    // 1️⃣ Save the form first
    await handleSave();

    // 2️⃣ Update status to "Submitted"
    await api.post(
      `/MyForms/UpdateStatus?formId=${formData.form.id}`,
      121440001,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

    // 3️⃣ Get updated form data
    const response = await api.get(
      `/Form/ViewExternalForm/${formId}`
    );

    setFormData(response.data);

    // 4️⃣ Set readonly mode based on status
    setReadonlyMode(
      [121440001].includes(response.data?.form?.statusReasonValue)
    );

    // 5️⃣ Lock UI after submission
    setSubmitted(true);
    setReadonlyMode(true);
  setBlocked(false);
    // 6️⃣ Success popup
    $.alert({
      title: "Success",
      content: "Form submitted and marked as completed!",
      type: "green",
    });

  } catch (error) {
    debugger;
      setBlocked(false);
    alert("Error while submitting the form.");
    console.error("Submission error:", error);
  }
};



const handleDownloadAttachment = (noteId, fileName) => {
api.get(`/FormAttachment/DownloadAttachment?noteId=${noteId}`, {
      responseType: "blob",
    })
    .then((res) => {
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
    })
    .catch((err) => console.error("Download error:", err));
};


  const tableHeaderStyle = {
    backgroundColor: "#007bff", // Blue header
    color: "white",
    fontWeight: "bold",
    padding: "10px",
    textAlign: "left",
    borderBottom: "2px solid #0056b3",
  };

  const tableRowStyleEven = {
    backgroundColor: "#f9f9f9", // Light gray row
  };

  const tableRowStyleOdd = {
    backgroundColor: "#ffffff", // White row
  };

  const tableCellStyle = {
    padding: "10px",
    borderBottom: "1px solid #ddd",
  };

  const tableInputStyle = {
    width: "100%",
    padding: "8px",
    border: "1px solid #ccc",
    borderRadius: "4px",
    fontSize: "14px",
    backgroundColor: "#f7f9fc",
  };
  const formContainerStyle = {
    width: "90%",
    margin: "auto",
    backgroundColor: "#fff",
    padding: "20px",
    borderRadius: "8px",
    boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
    border: "1px solid #ddd",
  };

  const sectionHeaderStyle = {
    backgroundColor: "#f7f7f7",
    padding: "10px",
    borderRadius: "6px",
    fontSize: "18px",
    fontWeight: "bold",
    textAlign: "center",
    marginBottom: "15px",
  };
 
  const backdropStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  background: "rgba(0,0,0,0.2)", // light dark shade
  zIndex: 9998,
  cursor: "wait"  // cursor changes to loading
};

const overlayStyle = {
  position: "fixed",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  background: "#222",
  padding: "30px 50px",
  borderRadius: "12px",
  zIndex: 9999,
  color: "#fff",
  fontSize: "22px",
  textAlign: "center",
  cursor: "wait" // cursor loading
};

   function normalizeFormValues(formData, formValues) {
    const normalizedValues = {};

    formData.listSections?.forEach((section, sectionIndex) => {
      section.listComponent?.forEach((component, compIndex) => {
        debugger;
        const id = component.id;
        const type = component.typeText;

        const keyBase = `${sectionIndex}-${compIndex}`;
        let value = "";

        switch (type) {
          case "Label & Number Textbox":
            value = formValues[id];
            break;

          case "Single Line Textbox":
            value = formValues[`${keyBase}-text`] || "";
            break;

          case "Multiline Textbox":
            value = formValues[`${keyBase}-textarea`] || "";
            break;

          case "Date":
            value = formValues[`${keyBase}-date`] || "";
            break;

          // case "Radio Buttons":
          //   value = formValues[`${keyBase}-radio`] || "";
          //   break;

          // case "Dropdown":
          //   value = formValues[`${keyBase}-select`] || "";
          //   break;

          // case "Checkbox":
          //   // checkboxes may be multiple entries
          //   const selected = [];
          //   for (let i = 1; i <= 30; i++) {
          //     const k = `${keyBase}-checkbox-${i}`;
          //     if (formValues[k]) selected.push(formValues[k]);
          //   }
          //   value = selected.join(",");
          //   break;

          default:
            break;
        }

        if (value !== undefined) {
          normalizedValues[id] = value;
        }
      });
    });

    return normalizedValues;
  }
    const renderColumn = (column, rowIndex, columnIndex) => {
    const labelStyle = {
      fontSize: "16px",
      fontWeight: "bold",
      marginBottom: "4px",
      display: "block",
      minWidth: "120px", // Ensures labels are aligned
    };

    const inputStyle = {
      width: "100%",
      padding: "5px",
      border: "1px solid #ccc",
      borderRadius: "4px",
      fontSize: "14px",
    };

    const optionContainerStyle = {
      // display: "grid",
      // gridTemplateColumns: `auto auto auto`,
      // gap: "10px",
      alignItems: "center",

    };

    const handleOperandChange = (componentId, value) => {
      debugger;
      setFormValues(prev => {
        let updated = { ...prev, [componentId]: value };
        let hasChanged = true;

        while (hasChanged) {
          hasChanged = false;

          formData.listCalculation.forEach(calc => {
            const aVal = parseFloat(updated[calc.operandAId]) || 0;
            const bVal = parseFloat(updated[calc.operandBId]) || 0;
            let result = 0;

            switch (calc.operatorText) {
              case 'Add':
                result = aVal + bVal;
                break;
              case 'Subtract':
                result = aVal - bVal;
                break;
              case 'Multiply':
                result = aVal * bVal;
                break;
              case 'Divide':
                result = bVal !== 0 ? aVal / bVal : 0;
                break;
            }

            if (updated[calc.resultId] !== result) {
              updated[calc.resultId] = result;
              hasChanged = true;
            }
          });
        }

        return updated;
      });
    };



 
    switch (column.typeValue) {
    
      case 121440002:
        return (
          <h3 style={{ textAlign: "center", fontSize: "24px", fontWeight: "bold" }}>
            {column.header}
          </h3>);
      case 121440003:
        return (
          <h4 style={{ textAlign: "left", fontSize: "20px", fontWeight: "bold", marginLeft: '10px' }}>
            {column.subHeader}
          </h4>
        );
      case 121440004:
        return (
          <div>
            {column.onlyTextParas && column.onlyTextParas.length > 0 ? (
              column.onlyTextParas.map((str, index) =>
                str.trim() !== "" ? (
                  <p key={index} style={{ textAlign: "left", marginBottom: 0 }}>{str}</p>
                ) : (
                  <br key={index} />
                )
              )
            ) : null}
          </div>
        );
      case 121440005:
debugger;

        return (

          <div style={{ display: "flex", flexDirection: "column" }}>
            <label style={labelStyle}>
              {column.singleLineTextboxLabel}
              {column.isMandatory && <span style={{ color: "red" }}> *</span>}
            </label>
            <input
              type="text"
              id="singleline"
              style={inputStyle}
   value={formValues[column.id] ?? column.singleLineTextboxValue ?? ""}
              onChange={(e) => setFormValues({ ...formValues, [column.id]: e.target.value })}
              maxLength={1000}
               disabled={readonlyMode} // ✅ Add this
            />
                <span id="spansline" className="field-validation-valid" style={{ color: "red" }}></span>
          </div>
        );
     case 121440006:
  return (
    <div style={{ marginBottom: "20px" }}>
      <label
        style={{
          display: "block",
          fontWeight: "600",
          marginBottom: "8px",
          color: "#374151", // Tailwind's gray-700
        }}
      >
        {column.multilineTextboxLabel}
        {column.isMandatory && <span style={{ color: "red" }}> *</span>}
      </label>

      <textarea
         id="multiLine"
        rows={column.mltxtRows}
        maxLength={5000}  
        value={
    formValues[column.id] !== undefined
      ? formValues[column.id]
      : (column.multilineTextboxValue || "")
  }
  onChange={(e) =>
    setFormValues({ ...formValues, [column.id]: e.target.value })
  }
        disabled={readonlyMode}
        style={{
          width: "100%",
          resize: "vertical",
      
        }}
      />
      <span id="spanMultiLine" className="field-validation-valid" style={{ color: "red" }}></span>
    </div>
  );

      case 121440007:
        return (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <label style={labelStyle}>
              {column.dateTextboxLabel}
              {column.isMandatory && <span style={{ color: "red" }}> *</span>}
            </label>
           <input
  id="date"
  type="date"
  style={inputStyle}
  value={
   formValues[column.id] ??
   (column.dateTextboxValue
      ? new Date(column.dateTextboxValue).toISOString().split("T")[0]
      : "")
}
  onChange={(e) => setFormValues({ ...formValues, [column.id]: e.target.value })}
  disabled={readonlyMode}
/>
   <span id="spandate" className="field-validation-valid" style={{ color: "red" }}></span>
          </div>
        );

     case 121440008:
  debugger;

  const componentId = column.id;
  const label = column.numberTextboxLabel || "Number Input";

  const isOperand = formData.listCalculation.some(
    calc => calc.operandAId === componentId || calc.operandBId === componentId
  );

  const isResult = formData.listCalculation.some(
    calc => calc.resultId === componentId
  );

  const currentValue =
    formValues[componentId] ??
    column.numberTextboxValue ??
    "";
    const displayValue = currentValue === 0 ? "" : currentValue;

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>                                                                            
      <label style={{
      fontSize: "16px",
      fontWeight: "bold",
      display: "block",
      minWidth: "120px", // Ensures labels are aligned
      }}>                                                                                                                                                                                                                                                      
        {column.numberTextboxLabel}                                                                 
        {column.isMandatory && <span style={{ color: "red" }}> *</span>}                                                                                            
      </label>

      <input  
       id="number"                  
        type="number"
        style={inputStyle}                                                                                                  
        value={displayValue}
        onChange={
          isOperand
            ? (e) => handleOperandChange(componentId, e.target.value)
            : (e) =>
                setFormValues(prev => ({
                  ...prev,
                  [componentId]: e.target.value
                }))
        }
        disabled={readonlyMode}
      />
             <span id="spannumber" className="field-validation-valid" style={{ color: "red" }}></span>
    </div>
  );


  case 121440009:
    debugger;
  const radioOptions = [];
  for (let i = 1; i <= 30; i++) {
    const label = column[`radioButtonOpt${i}Label`];
    if (label) {
      radioOptions.push({ value: i.toString(), text: label });
    }
  }

  const compId = column.id;
 const selected =
  formValues[compId]?.toString() ||
  column.radioButtonsValue?.toString() ||
  "";


  return (
        <div style={{ marginBottom: '20px' }}>
      <label style={{ fontWeight: 'bold', fontSize: '16px', marginBottom: '4px', display: 'block' }}>
        {column.radioButtonsLabel}
     <span style={{ color: "red" }}> *</span>
      </label>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '15px' }}>
        {radioOptions.map((option, index) => (
          <label
            key={index}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              backgroundColor: '#f8f9fa',
              padding: '6px 12px',
              borderRadius: '8px',
              border: '1px solid #ddd',
              cursor: readonlyMode ? 'not-allowed' : 'pointer',
            }}
          >
            <input
            id="radbtn"
              type="radio"
              name={`radio-${compId}`}
              value={option.value}
              checked={selected === option.value}
              onChange={(e) =>
                setFormValues((prev) => ({
                  ...prev,
                  [compId]: e.target.value,
                }))
              }
              disabled={readonlyMode}
              style={{ accentColor: '#007bff' }}
            />
            {option.text}
          </label>
        ))}
      </div>
                  <span
              id="spanrad"
              className="field-validation-valid"
              style={{ color: "red" }}
            ></span>
    </div>
  );

case 121440010:
  const checkboxOptions = [];
  for (let i = 1; i <= 30; i++) {
    const label = column[`checkboxOpt${i}Label`];
    if (label) {
      checkboxOptions.push({
        key: `checkboxOpt${i}`,
        valueKey: `checkboxOpt${i}Value`,
        value: i,
        text: label,
      });
    }
  }

  const compid = column.id;

  const handleCheckboxChange = (key) => {
    setFormValues((prev) => ({
      ...prev,
      [compid]: {
        ...prev[compid],
        [key]: !prev[compid]?.[key],
      },
    }));
  };

  return (
    <div style={{ marginBottom: '20px' }}>
      <label style={{ fontWeight: 'bold', fontSize: '16px', marginBottom: '8px', display: 'block' }}>
        {column.checkboxLabel}
<span style={{ color: "red" }}> *</span>
      </label>

      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '15px' }}>
        {checkboxOptions.map((option, index) => {
        const valueKey = option.valueKey;
          const initialValue = column[valueKey] || false; // Default to false if server value is null/undefined

          // Check formValues first, then fallback to the initial value from column data
          const isChecked = formValues[compid]?.[valueKey] !== undefined
            ? formValues[compid][valueKey] === true
            : initialValue;
          // ------------------------
          return (
            <div>
            <label
              key={index}
              htmlFor={`${compid}-${option.key}`}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                backgroundColor: '#f1f3f5',
                padding: '6px 12px',
                borderRadius: '8px',
                border: '1px solid #ccc',
                cursor: readonlyMode ? 'not-allowed' : 'pointer',
              }}
            >
              <input
                type="checkbox"
               id="checkbox"
                checked={isChecked}
                onChange={() => handleCheckboxChange(valueKey)}
                disabled={readonlyMode}
                style={{ accentColor: '#28a745' }}
              />
              {option.text}
            </label>

                    </div>
          );
        })}
                    <span
                      id="spancheck"
                      className="field-validation-valid"
                      style={{ color: "red" }}
                    ></span>
      </div>
    </div>
  );

      case 121440011:
        const listboxOptions = [];
        for (let i = 1; i <= 30; i++) {
          const label = column[`listboxOpt${i}Label`];
          if (label) {
            listboxOptions.push({ value: i.toString(), text: label });
          }
        }
        const comp = column.id;
        const selectedValue = formValues[comp] ? String(formValues[comp]) : "";

        return (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <label style={{ fontSize: "16px", fontWeight: "bold", marginBottom: "6px" }}>
              {column.listboxLabel}&nbsp;: &nbsp;
        <span style={{ color: "red" }}> *</span>
            </label>

            <select
             id="listbox"
              value={column.listboxValue}
              onChange={(e) =>
                setFormValues((prev) => ({
                  ...prev,
                  [comp]: e.target.value,
                }))
              }
               disabled={readonlyMode} // ✅ Add this 
              style={{
                width: "100%",
                padding: "5px",
                borderRadius: "4px",
                border: "1px solid #ccc",
                fontSize: "14px",
                backgroundColor: "#f7f9fc",
                cursor: "pointer",
                outline: "none",
                appearance: "none",
                backgroundImage:
                  "url('data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" fill=\"black\"><path fill-rule=\"evenodd\" d=\"M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z\" clip-rule=\"evenodd\"/></svg>')",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "right 10px center",
                backgroundSize: "12px",
              }}
            >
              <option value="">-- Select --</option>
              {listboxOptions.map((option, index) => (
                <option key={index} value={option.value}>
                  {option.text}
                </option>
              ))}
            </select>
            <span
              id="spanlistbox"
              className="field-validation-valid"
              style={{ color: "red" }}
            ></span>
          </div>
        );
      // 👇 The actual Table component inside your switch-case
      case 121440012: {
        const tableHeaders = [];
        for (let i = 1; i <= 6; i++) {
          const header = column[`tableHeader${i}`];
          if (header?.trim()) {
            tableHeaders.push({ value: i.toString(), text: header.trim() });
          }
        }

        const numberOfRows = Number(column.tableRows) || 1;

        const existingValues = formValues[column.id]?.values;
        const existingTableValueId = formValues[column.id]?.tableValueId;

        const tableData = existingValues || column.tableValues || {};
        const tableValueId = existingTableValueId || column.tableValuesId || column.tableValueId;

        return (
          <div>
            <label style={{ fontWeight: "bold", fontSize: "16px", marginBottom: "8px", display: "block", textAlign: "center" }}>
              {column.tableLabel}
            </label>
            <table
            style={{
              width:"100%",
              borderCollapse:"collapse", 
              marginTop:"10px", 
              border:"1px solid rgb(204,204,204)",
            }}>
              <thead>
                <tr>
                  {tableHeaders.map((option, index) => (
                    <th key={index} style={tableHeaderStyle}>{option.text}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {Array.from({ length: numberOfRows }).map((_, rowIdx) => (
                  <tr key={rowIdx} style={rowIdx % 2 === 0 ? tableRowStyleEven : tableRowStyleOdd}>
                    {tableHeaders.map((_, colIdx) => {
                      const cellKey = `c${colIdx + 1}R${rowIdx + 1}`; // use lowercase 'c'

                      console.log("Table Data Keys for column", column.id, Object.keys(tableData));

                      return (
                        <td key={colIdx} style={tableCellStyle}>
                          <input
                            type="text"
                            maxLength={100}
                            style={tableInputStyle}
                            value={tableData[cellKey] || ""}
                            onChange={(e) => {
                              const newValue = e.target.value;

                              setFormValues((prevFormValues) => {
                                const prevComponent = prevFormValues[column.id] || {};
                                const prevTableValues = prevComponent.values || {};

                                // Clone the values
                                const updatedValues = { ...prevTableValues, [cellKey]: newValue };

                                return {
                                  ...prevFormValues,
                                  [column.id]: {
                                    ...prevComponent,
                                    tableValueId: tableValueId,
                                    values: updatedValues,
                                  },
                                };
                              });
                            }}
                           disabled={readonlyMode} // ✅ Add this

                          />
                        </td>
                      );
                    })}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        );
      }

      default:
        return null;
    }
  };

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error}</p>;
   return (


    <div
      style={{
        width: "90%",
        margin: "auto",
        backgroundColor: "#fff",
        padding: "20px",
        borderRadius: "8px",
        boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
        border: "1px solid #ddd",
      }}
      disabled={readonlyMode}
    >
{blocked && (
  <>
    {/* FULL SCREEN BACKDROP THAT BLOCKS CLICKS */}
    <div style={backdropStyle}></div>

    {/* CENTER BOX */}
    <div style={overlayStyle}>
      <div className="spinner-border" role="status"></div>
      <div>Please wait…</div>
    </div>
  </>
)}
     {Array.isArray(formData?.listSections) &&
  formData.listSections.map((section, sectionIndex) => (
      
        <div key={section.id} style={{ marginBottom: "20px" }}>

          {section.listRows.map((row, rowIndex) => {
            const isFullWidth = row.isFull;

            return (
              <div
                key={rowIndex}
                style={{
                  display: "grid",
                  gridTemplateColumns: isFullWidth
                    ? "1fr"
                    : `repeat(${section.noOfColumns}, 1fr)`,
                  gap: "10px",
                  marginBottom: "15px",
                }}
              >
                {row.formColumn1 && renderColumn(row.formColumn1, rowIndex, 1)}
                {!isFullWidth && row.formColumn2 && renderColumn(row.formColumn2, rowIndex, 2)}
                {!isFullWidth && row.formColumn3 && renderColumn(row.formColumn3, rowIndex, 3)}
                {!isFullWidth && row.formColumn4 && renderColumn(row.formColumn4, rowIndex, 4)}
              </div>

            );
          })}
        </div>
      ))}

<div
  style={{
    display: "flex",
    alignItems: "center",
    gap: "8px", // equal space between all buttons
    padding: "20px 0",
    flexWrap: "wrap", // responsive (wraps on small screens)
  }}
>
  
  {/* Back Button */}

  {/* Conditional Buttons */}
  {(formData.form.statusReasonValue === 1 ||
    formData.form.statusReasonValue === 121440000) && (
    <>
      {/* Save Button */}
      <button
        type="submit"
        onClick={handleSave}
        style={{
          padding: "8px 16px",
          backgroundColor: "#28a745",
         color:"rgb(255,255,255)",
          border: "none",
          borderRadius: "6px",
               fontSize: "15px",
          fontWeight: "bold",
          cursor: "pointer",
          transition: "all 0.3s ease",
        }}
        disabled={readonlyMode}
      >
        Save
      </button>

      {/* Submit Button */}
      <button
        type="button"
             onClick={handleSubmit}
        style={{
          padding: "8px 16px",
          backgroundColor: "#ffc107",
          color: "black",
          border: "none",
          borderRadius: "6px",
           fontSize: "15px",
         fontWeight: "bold",
          cursor: "pointer",
          transition: "all 0.3s ease",
        }}
       disabled={readonlyMode}
      >
        Submit
      </button>
    </>
  )}

</div>
  
{/* 💬 Comment Modal */}

{showAttachmentSection && (
  <div 
  disabled={readonlyMode}
  style={{ marginTop: "30px" }}>

     {(formData.form.statusReasonValue === 1 ||
    formData.form.statusReasonValue === 121440000) && (
      <>
    <h3 style={{ fontWeight: "bold" }}>📎 Form Attachments</h3>

    <div style={{ display: "flex", marginBottom: "10px", alignItems: "center", gap: "12px" }}>
      <input
        type="file"
        onChange={(e) => setSelectedFile(e.target.files[0])}
        style={{ border: "1px solid #d1d5db", padding: "6px", borderRadius: "6px" }}
      />
      <button
        onClick={handleUploadAttachment}
        style={{
          padding: "8px 16px",
          backgroundColor: "#3b82f6",
          color: "white",
          border: "none",
          borderRadius: "6px",
          fontWeight: "bold",
          cursor:"pointer"
        }}
          disabled={readonlyMode}

      >
        Upload
      </button>
    </div>
    </>
    )}

    <table className="table table-bordered table-sm">
      <thead className="thead-light">
        <tr>
          <th>Added By</th>
          <th>Added On</th>
          <th>File</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {attachments.length === 0 ? (
          <tr>
            <td colSpan="4" style={{ textAlign: "center" }}>No attachments found.</td>
          </tr>
        ) : (
          attachments.map((a) => (
            <tr key={a.id}>
              <td>{a.addedBy}</td>
              <td>{new Date(a.createdOn).toLocaleString()}</td>
              <td>{a.fileName}</td>
              <td>
                <button
                  className="btn btn-sm btn-primary"
                  onClick={() => handleDownloadAttachment(a.id, a.fileName)}
                  title="Download"
                >
                  <i className="fa fa-download" />
                </button>
                &nbsp;
                {userId === formData.form.reviewerId && (
                  <button
                    className="btn btn-sm btn-danger"
                    onClick={() => handleDeleteAttachment(a.id)}
                    title="Delete"
                  >
                    <i className="fa fa-trash" />
                  </button>
                )}
              </td>
            </tr>
          ))
        )}
      </tbody>
    </table>
  </div>
)}

    </div>

  );
}

export default ViewExternalForm